import { render, staticRenderFns } from "./PaymentLayout.vue?vue&type=template&id=654a9267&scoped=true&"
import script from "./PaymentLayout.vue?vue&type=script&lang=js&"
export * from "./PaymentLayout.vue?vue&type=script&lang=js&"
import style0 from "./PaymentLayout.vue?vue&type=style&index=0&id=654a9267&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "654a9267",
  null
  
)

component.options.__file = "PaymentLayout.vue"
export default component.exports